<template>
  <Teleport to="body">
    <Transition
      enter-active-class="transition duration-200 ease-out"
      enter-from-class="transform opacity-0"
      enter-to-class="opacity-80"
      leave-active-class="transition duration-200 ease-in"
      leave-from-class="opacity-80"
      leave-to-class="transform opacity-0"
    >
      <div
        v-if="modelValue"
        class="fixed inset-0 z-50 overflow-y-auto"
        aria-labelledby="modal-title"
        role="dialog"
        aria-modal="true"
      >
        <!-- Fond sombre avec flou -->
        <div
          class="fixed inset-0 bg-opacity-50 transition-opacity duration-150 ease-in-out backdrop-blur-sm"
        ></div>

        <!-- Contenu du modal -->
        <div
          class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
        >
          <div
            class="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg"
          >
            <div class="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
              <div class="sm:flex sm:items-start">
                <div
                  class="mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10"
                >
                  <AlertTriangleIcon class="h-6 w-6 text-red-600" />
                </div>
                <div class="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                  <h3 id="modal-title" class="text-base font-semibold leading-6 text-gray-900">
                    {{ title }}
                  </h3>
                  <div class="mt-2">
                    <p class="text-sm text-gray-500 whitespace-pre-line">
                      {{ message }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
              <button
                type="button"
                class="inline-flex w-full justify-center rounded-md bg-red-600 px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-red-500 sm:ml-3 sm:w-auto"
                @click="confirm"
              >
                {{ confirmText }}
              </button>
              <button
                type="button"
                class="mt-3 inline-flex w-full justify-center rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:bg-gray-50 sm:mt-0 sm:w-auto"
                @click="cancel"
              >
                {{ cancelText }}
              </button>
            </div>
          </div>
        </div>
      </div>
    </Transition>
  </Teleport>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { AlertTriangleIcon } from 'lucide-vue-next'

export default defineComponent({
  name: 'ModalAreYouSure',
  components: {
    AlertTriangleIcon,
  },
  props: {
    modelValue: {
      type: Boolean,
      required: true,
    },
    title: {
      type: String,
      default: 'Êtes-vous sûr ?',
    },
    message: {
      type: String,
      default: 'Cette action ne pourra pas être annulée.',
    },
    confirmText: {
      type: String,
      default: 'Confirmer',
    },
    cancelText: {
      type: String,
      default: 'Annuler',
    },
  },
  emits: ['update:modelValue', 'confirm', 'cancel'],
  setup(_, { emit }) {
    const confirm = (): void => {
      emit('update:modelValue', false)
      emit('confirm')
    }

    const cancel = (): void => {
      emit('update:modelValue', false)
      emit('cancel')
    }

    return {
      confirm,
      cancel,
    }
  },
})
</script>
